import React from 'react';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { toast } from 'react-toastify';
import styles from './CopyButton.module.css';

const CopyButton = ({ textToCopy }) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      toast.success('Copied!');
    } catch (err) {
      return
    }
  };

  return (
    <button className={styles.copyButton} onClick={handleCopy}>
      <FileCopyIcon className={styles.copyButtonIcon} />
    </button>
  );
};

export default CopyButton;
